module.exports = __webpack_public_path__ + "img/model_03.0dc84b34.png";